var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-card"},[_vm._t("advertise"),_c('div',{staticClass:"content-card__form"},[_vm._t("form")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }